import React, { useEffect } from 'react';
import { PurchaseToast } from './components/PurchaseToast';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { StopSearching } from './components/StopSearching';
import { SystemSection } from './components/SystemSection';
import { ModulesSection } from './components/ModulesSection';
import { PreviewCarousel } from './components/PreviewCarousel';
import { BonusSection } from './components/BonusSection';
import { DifferentiatorSection } from './components/DifferentiatorSection';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
interface AppProps {
  /** Show the rotating "just purchased" social-proof popup. */
  showPurchasePopup?: boolean;
}
export function App({
  showPurchasePopup = true
}: AppProps) {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    try {
      // Meta Pixel initialization (hardened against sandboxed previews)
      ;
      (function (f: any, b: any, e: any, v: any) {
        if (f.fbq) return;
        const n: any = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        const t = b.createElement(e);
        t.async = !0;
        t.src = v;
        const s = b.getElementsByTagName(e)[0];
        if (s && s.parentNode) {
          s.parentNode.insertBefore(t, s);
        } else {
          ;
          (b.head || b.documentElement).appendChild(t);
        }
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      (window as any).fbq('init', '1492774178719165');
      (window as any).fbq('track', 'PageView');
    } catch (err) {
      console.warn('Meta Pixel init skipped:', err);
    }
  }, []);
  return <>
      <noscript data-id="element-0" data-mp="3ucje3y95kjvu">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1492774178719165&ev=PageView&noscript=1" alt="" data-id="element-1" data-mp="3uf5gljh6s977" />
      </noscript>

      <div className="min-h-screen w-full overflow-x-hidden bg-tech text-carbon" data-id="element-2" data-mp="3gkv17sr2xrdt">
        <main data-id="element-3" data-mp="3bmbf9schkflg">
          <Hero data-id="element-4" data-mp="3bmtjbb5e3y3x" />
          <ProblemSection data-id="element-5" data-mp="3bncpjulogy24" />
          <StopSearching data-id="element-6" data-mp="3bnus18yxo8ih" />
          <SystemSection data-id="element-7" data-mp="3bkgrm69ty9do" />
          <ModulesSection data-id="element-8" data-mp="3qbppf2nvz11w" />
          <PreviewCarousel data-id="element-9" data-mp="3qbze8mx73260" />
          <BonusSection data-id="element-10" data-mp="3qdakqui0yo0t" />
          <DifferentiatorSection data-id="element-11" data-mp="3lkr5lt3ovktw" />
          <Offer data-id="element-12" data-mp="3ljg0npyic717" />
          <Guarantee data-id="element-13" data-mp="3liwm8j82g0rx" />
          <Testimonials data-id="element-14" data-mp="3limrkic2t5fw" />
          <FAQ data-id="element-15" data-mp="2xumznf3138zq" />
          <FinalCTA data-id="element-16" data-mp="2xu3iw1p46qna" />
        </main>
        <Footer data-id="element-17" data-mp="2xt2900ju4a75" />
      </div>

      {showPurchasePopup && <PurchaseToast data-id="element-18" data-mp="2swbtpffutims" />}
    </>;
}